'use strict';
import angular from 'angular';

import './scripts/guides.components';

angular.module('core.guides', [
    'guides.components'
]);